import styled from "styled-components"
import { Typography } from "antd"

const H1Styled = styled(Typography.Title)``

export default H1Styled
